export type HomeSubdivisionNode = {
  name: string;
  level: number;
  parent?: HomeSubdivisionNode | null;
};

/**
 * Public label for a home place: the place itself, plus its state when that
 * adds something. A neighborhood also keeps its city.
 */
export function formatHomeBaseName(
  subdivision: HomeSubdivisionNode | null | undefined,
): string | null {
  const leafName = subdivision?.name?.trim();
  if (!leafName || !subdivision) return null;

  const chain: HomeSubdivisionNode[] = [];
  let current: HomeSubdivisionNode | null | undefined = subdivision;
  while (current) {
    chain.push(current);
    current = current.parent;
  }

  const state = chain.find((place) => place.level === 1);
  const city = chain.find((place) => place.level === 3);
  const parts = [leafName];

  if (subdivision.level === 4 && city) {
    const cityName = city.name.trim();
    if (cityName && cityName.toLowerCase() !== leafName.toLowerCase()) {
      parts.push(cityName);
    }
  }

  const stateName = state?.name.trim();
  const last = parts[parts.length - 1] ?? leafName;
  if (
    state &&
    state !== subdivision &&
    stateName &&
    stateName.toLowerCase() !== last.toLowerCase()
  ) {
    parts.push(stateName);
  }

  return parts.join(", ");
}

/** Home place when one is saved. Older free text remains only when no place was matched. */
export function brokerBasedInLabel(
  profile: {
    locationName?: string | null;
    homeSubdivision?: HomeSubdivisionNode | null;
  } | null | undefined,
): string | null {
  return (
    formatHomeBaseName(profile?.homeSubdivision) ||
    profile?.locationName?.trim() ||
    null
  );
}
